// extracted by mini-css-extract-plugin
module.exports = {"dots":"styles_dots__GI4_X"};